// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();


// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();





// mobile-menu start

$(".header__mobi-menu").on("click", function () {
    $(this).toggleClass("active");
})

// mobile-menu end



// header start


function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;

        if (currentScroll > 0) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');

        if (currentScroll === 0) header.style.transform = 'translateY(0)';
        else if (currentScroll < lastScrollTop) header.style.transform = 'translateY(0)';
        else header.style.transform = 'translateY(-100%)';
        lastScrollTop = currentScroll;
    });
}
headerSticky();


// header end




// press-coverage-items slider start


if ($(Window).width() < 768) {
    $('.press-coverage__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
    });
}


$('.media-features__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.media-features__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// $(document).on("click", ".media-features__play-icon", function () {
//     let wrapper = $(this).closest(".media-features__img");
//     let video = wrapper.find("video").get(0);

//     video.play();
//     $(this).fadeOut();
// });

// $(document).on("click", ".media-features__img video", function () {
//     if (!this.paused) {
//         this.pause();
//         $(this).siblings(".media-features__play-icon").fadeIn();
//     }
// });


// press-coverage-items slider end


// banner-visit-modal start


$(".banner-visit__btn").on("click", function () {
    $(".banner-visit__inner").addClass("banner-modal-open");
})
$(".banner-visit__close").on("click", function () {
    $(".banner-visit__inner").removeClass("banner-modal-open");
})

// banner-visit-modal end




// Start Featured Product Hover Change Image
$('.featured-product-card__img-thumb').hover(
    function () {
        var thumbKey = $(this).attr('hover-thumb');
        var $card = $(this).closest('.featured-product-card');
        $card.find('.featured-product-card__img-thumb, .featured-product-card__img').removeClass('active');
        $(this).addClass('active');
        $card.find('.featured-product-card__img[hover-img="' + thumbKey + '"]').addClass('active');
    },
    function () {
        var $card = $(this).closest('.featured-product-card');
        $card.find('.featured-product-card__img-thumb, .featured-product-card__img').removeClass('active');
        $card.find('.featured-product-card__img-thumb').first().addClass('active');
        $card.find('.featured-product-card__img').first().addClass('active');
    }
);
// End Featured Product Hover Change Image


// Start Featured Product Tab
$('.featured-product__tab-btn').on('click', function (e) {
    e.preventDefault();
    var tabKey = $(this).attr('tab-data');
    var $wrapper = $(this).closest('.featured-product');
    $wrapper.find('.featured-product__tab-btn').removeClass('active');
    $(this).addClass('active');
    $wrapper.find('.featured-product__items').removeClass('active');
    $wrapper.find('.featured-product__items[tab-content="' + tabKey + '"]').addClass('active');
});
// End Featured Product Tab


// Start Product Spotlight Slider
if ($(window).width() < 768) {
    $(".lifestyle-gallery__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
}
$(".lifestyle-gallery__arrow-left").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickPrev");
});
$(".lifestyle-gallery__arrow-right").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickNext");
});
// End Product Spotlight Slider


// Start Spotlight Product Video Hide Show
$(document).ready(function () {
    $('.lifestyle-gallery__video-wrapper').on('click', function () {
        $('.lifestyle-gallery__video').toggleClass('video-hide');
        $('.lifestyle-gallery__img').toggleClass('img-show');
    });
})
// End Spotlight Product Video Hide Show



// Start Cart Drawer Product Slider
$(".cart-drawer__slider-items").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});
$(".cart-drawer__arrow-left").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickPrev");
});
$(".cart-drawer__arrow-right").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickNext");
});


$(".header__cart").on("click", function () {
    $("body").addClass("cart-drawer-open");
})


$(document).on("click", ".cart-drawer__close , .overlay", function () {
    $("body").removeClass("cart-drawer-open");
});



// End Cart Drawer Product Slider


$(document).ready(function () {

    $(".megamenu__left-item a").on("mouseenter", function () {
        $(".megamenu__left-item a").removeClass("active");
        $(this).addClass("active");
        var tabValue = $(this).data("tab");
        $(".megamenu__items").removeClass("active");
        $('.megamenu__items[data-contet="' + tabValue + '"]').addClass("active");

    });

});


$(".has-megamenu").hover(function () {
    $(".header__inner").toggleClass("megamenu-show");
});
// End Megamenu Product Tab



// Start Product Quantity 

$(".cart-drawer__plus").on("click", function () {
    let input = $(this).siblings("input");
    let value = parseInt(input.val()) || 0;
    input.val(value + 1);
});
$(".cart-drawer__minus").on("click", function () {
    let input = $(this).siblings("input");
    let value = parseInt(input.val()) || 0;

    if (value > 1) {
        input.val(value - 1);
    }
});

// End Product Quantity




$(".header__search").on("click", function () {
    $("body").addClass("search-open");
})
$(".search-bar__close").on("click", function () {
    $("body").removeClass("search-open");
})

$(window).on("scroll", function () {
    if ($(window).scrollTop() > 10) {
        $(".search-bar").addClass("search-bar-position");
    } else {
        $(".search-bar").removeClass("search-bar-position");
    }
});



$(".discover-collection__btn-review , .media-features__play-icon, .open-video-js").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("modal-open");
    let videoSrc = $(this).attr("data-att");
    let autoplaySrc = videoSrc + "?autoplay=1";
    $(".modal__video iframe").attr("src", autoplaySrc);
})
$(".modal__close , .overlay").on("click", function () {
    $("body").removeClass("modal-open");
})
// $(".discover-collection__btn-review , .media-features__play-icon").click(function () {
//     let videoSrc = $(this).attr("data-att");
//     let autoplaySrc = videoSrc + "&autoplay=1";
//     $(".modal__video iframe").attr("src", autoplaySrc);
// });
$(".modal__close , .overlay").click(function () {
    $(".modal__video iframe").attr("src", "");
});





// Start Dropdown and Tab Mobile
if ($(window).width() < 768) {
    $(".timeline__dropdown").on("click", function (e) {
        $(this).toggleClass("open");
        e.stopPropagation();
    });
    $(document).on("click", function () {
        $(".timeline__dropdown").removeClass("open");
    });
    $(".timeline__dropdown ul li").on("click", function (e) {
        e.stopPropagation();
        var selectedTab = $(this).data("tab");
        var selectedText = $(this).text();
        $(".timeline__dropdown ul li").removeClass("active");
        $(this).addClass("active");
        $(".timeline__dropdown").attr("data-selected", selectedText).removeClass("open");
        $(".timeline__item").removeClass("active");
        $('.timeline__item[data-content="' + selectedTab + '"]').addClass("active");
    });
}
// End Dropdown and Tab Mobile


//  accordion start

    $(".accordion__title.active").next(".accordion__content").show();

    $(".accordion__title:not(.open-on-desktop)").on("click", function () {
        var $content = $(this).next(".accordion__content");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $content.slideUp();
        } else {
            var $siblings = $(this).closest(".accordion").siblings(".accordion");
            $siblings.find(".accordion__title").removeClass("active");
            $siblings.find(".accordion__content").slideUp();

            $(this).addClass("active");
            $content.slideDown();
        }
      
    });
    $(".accordion__title.open-on-desktop").on("click", function () {
        if ($(window).width() > 1024) {
            $(this).parent().toggleClass("open");
        } else {
            var $content = $(this).next(".accordion__content");
            if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $content.slideUp();
            } else {
                var $siblings = $(this).closest(".accordion").siblings(".accordion");
                $siblings.find(".accordion__title").removeClass("active");
                $siblings.find(".accordion__content").slideUp();

                $(this).addClass("active");
                $content.slideDown();
            }
        }
    });
    //  accordion end


//  accordion end


// Start Time Line Item Slider & Custom SLider Dots
$(document).ready(function () {
    if ($(window).width() > 768) {
        var $bars = $(".timeline__bar");
        var $items = $(".timeline__items");
        $bars.css("width", 100 / $bars.length + "%").first().addClass("active");
        $items.slick({ slidesToShow: 1, slidesToScroll: 1, arrows: false, dots: false });
        $bars.on("click", function () {
            $items.slick("slickGoTo", $(this).index());
        });
        $items.on("beforeChange", function (e, slick, current, next) {
            $bars.removeClass("active").eq(next).addClass("active");
        });
    }
    $(".timeline__arrow-prev").click(function () {
        $(this).closest(".timeline").find(".slick-slider").slick("slickPrev");
    });
    $(".timeline__arrow-next").click(function () {
        $(this).closest(".timeline").find(".slick-slider").slick("slickNext");
    });
});
// End Time Line Item Slider & Custom SLider Dots











// Mobile Menu
$(".header__mobi-menu").on("click", function () {
    $(this).toggleClass("active");
    $(".header__mobi-menu").toggleClass('active');
    $("body").toggleClass("mobile__menu-open");
    $('.header__inner').toggleClass('header-color-change');
});


$(".menu-drawer__sub-menu").on('click', function () {
    $(this).find(".menu-drawer__sub-menu-wrapper").addClass('sub-menu-active');
});
$(".menu-drawer__sub-menu-back").on('click', function (e) {
    e.stopPropagation();
    $(this).closest(".menu-drawer__sub-menu-wrapper").removeClass('sub-menu-active');
});

$(".header__cart").on("click", function () {
    $("body").removeClass("mobile__menu-open");
    $(".header__mobi-menu").removeClass("active");
    $(".header__inner").removeClass("header-color-change");
});




// Start Shop Product Griding System For Poster Card & Featured Product Tab
$(document).ready(function () {
    function repositionPoster() {
        if ($(window).width() < 768) return;
        $('.shop-product__item').each(function () {
            var $container = $(this);
            var $poster = $container.find('.featured-product-card_poster');
            if (!$poster.length) return;
            $container.append($poster);
            var $cards = $container.find('.featured-product-card:not(.featured-product-card_poster)');
            var targetIndex = $(window).width() >= 1024 ? 3 : $cards.length;
            if ($cards.length >= targetIndex) {
                $cards.eq(targetIndex - 1).after($poster);
            }
        });
    }

    repositionPoster();

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(repositionPoster, 150);
    });

    $('.shop-product__tabs .shop-product__tab').on('click', function () {
        var tabTarget = $(this).data('tab');

        $('.shop-product__tabs .shop-product__tab').removeClass('active');
        $(this).addClass('active');

        $('.shop-product__items .shop-product__item').removeClass('active');
        $('.shop-product__items .shop-product__item[tab-content="' + tabTarget + '"]').addClass('active');

        repositionPoster();
    });

});
// End Shop Product Griding System For Poster Card & Featured Product Tab


// Start Product Collectins Slider MObile

if ($(window).width() < 768) {
    $(".product-collections__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
}

// End Product Collectins Slider MObile






$(document).ready(function () {
    $('.media-coverage__tab').on('click', function () {
        var type = $(this).data('type');
        $('.media-coverage__tab').removeClass('active');
        $(this).addClass('active');
        $('.media-coverage__items').removeClass('active');
        $('.media-coverage__items').each(function () {
            if ($(this).data('content') === type) {
                $(this).addClass('active');
            }
        });
    });
});









$(document).ready(function () {
    const $video = $('.video-banner__video video');
    const videoElement = $video.get(0);
    const $playIcon = $('.video-banner__play-icon');
    const $playImg = $('.video-banner__play-img');
    const $pauseImg = $('.video-banner__pause-img');
    const $soundBtn = $('.video-banner__sound');
    const $soundImg = $('.video-banner__sound-img');
    const $muteImg = $('.video-banner__mute-img');
    $soundImg.show();
    $muteImg.hide();
    $playImg.hide();
    $pauseImg.show();
    if (videoElement) {
        const playPromise = videoElement.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => {
                videoElement.muted = true;
                videoElement.play();
                $soundImg.hide();
                $muteImg.show();
            });
        }
    }
    $playIcon.on('click', () => {
        if (videoElement.paused) {
            videoElement.play();
            $playImg.hide();
            $pauseImg.show();
        } else {
            videoElement.pause();
            $playImg.show();
            $pauseImg.hide();
        }
    });
    $soundBtn.on('click', () => {
        if (videoElement.muted) {
            videoElement.muted = false;
            $soundImg.show();
            $muteImg.hide();
        } else {
            videoElement.muted = true;
            $soundImg.hide();
            $muteImg.show();
        }
    });
});



if ($(Window).width() < 768) {
    $('.product-in-the-wild__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        // adaptiveHeight: true,
    });
}

if($('.page-hero__btn a').length > 0) {
document.querySelector('.page-hero__btn a').addEventListener('click', function(e) {
  e.preventDefault();

  const target = document.querySelector('#military_form');

  if (target) {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
});
}





// Start Single Product Left Site Height
// if ($(Window).width() > 768) {
//     setTimeout(function () {
//         var left_height = $('.single-product__left').height();
//         var right_height = $('.single-product__right').height();
//         if (left_height > right_height) {
//             $('.single-product__wrapper').height(left_height);
//         }
//         else {
//             $('.single-product__wrapper').height(right_height);
//         }
//     }, 500); // 500 milliseconds = 5 seconds
// }

// End Single Product Left Site Height



// Start Slider Toggle Button Single Product
$('#toggle').on('click', function () {
    $(this).toggleClass('toggle__btn_night');
    var isNight = $(this).hasClass('toggle__btn_night');
    $(".single-product__slider .single-product__slider-bgcolor-img").toggleClass('active', isNight);
    $(".single-product__modal-item .single-product__slider-bgcolor-img").toggleClass('active', isNight);
});
// End Slider Toggle Button Single Product

// Start Single Product Slider & Modal

var $slider = $(".single-product__slider");
var $modalSlider = $(".single-product__modal-item");
var isDesktop = $(window).width() >= 768;
$slider.find(".single-product__slider-img-item").each(function () {
    $modalSlider.append($(this).clone());
});
if($modalSlider.find('.single-product__slider-img-item').length > 1) {
    $modalSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}
if (isDesktop) {
    $slider.find(".single-product__slider-img-item").not(":first").hide();
}
if (!isDesktop) {
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
    });
}
$slider.on("click", ".single-product__slider-img-item", function () {
    var index;
    if (isDesktop) {
        index = $slider.find(".single-product__slider-img-item").index(this);
    } else {
        index = $(this).closest(".slick-slide").data("slick-index");
    }
    var isNight = jQuery(".toggle__btn").hasClass("toggle__btn_night");
    $(".single-product__modal").addClass("active");
    $("body").addClass("slider-modal-open");
    $modalSlider.slick("slickGoTo", index, true);
    $(".single-product__modal-item .single-product__slider-bgcolor-img").toggleClass("active", isNight);
});
$(".single-product__modal-close").on("click", function () {
    $(".single-product__modal").removeClass("active");
});
$modalSlider.on("click", ".slick-current", function () {
    const $img = $(this).find("img");
    $img.toggleClass("zoomed");
    $(".slick-dots").toggleClass("active", $img.hasClass("zoomed"));
});
$(".single-product__arrow-left").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickPrev");
});
$(".single-product__arrow-right").click(function () {
    $(this).parent().parent().parent().find(".slick-slider").slick("slickNext");
});

// End Single Product Slider & Modal
/* ======
  var $slider = (".single-product__slider");
  function initSlider() {
    if ($(window).width() < 768) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          arrows: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    } else if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
  initSlider();
  var resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSlider, 150);
  });
======*/

// Start Add To Cart Loading Animation


function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();
    clearTimeout($parent.data("loadingTimeout"));
    $parent.addClass("loading");
    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);
    $parent.data("loadingTimeout", timeoutId);
}
$(document).on("click", ".click-loading", function (e) {
    e.preventDefault();
    handleLoading($(this));
});



// End Add To Cart Loading Animation



$(window).on("scroll", function () {
    if ($(this).scrollTop() > 0) {
        $("body").addClass("page-scroll");
    } else {
        $("body").removeClass("page-scroll");
    }
});



// Start External Links Open In New Tab
(function () {
    // Hostnames here (and their subdomains) are treated as internal and will NOT
    // be forced to open in a new tab. Add your custom domain, myshopify domain,
    // CDN/checkout subdomains, etc.
    const INTERNAL_HOSTNAMES = [
        window.location.hostname,
        'vertex-watches.com',
        'myshopify.com',
        'shopify.com',
        'cdn.shopify.com'
    ];

    function isInternalHostname(hostname) {
        if (!hostname) return false;
        const host = hostname.toLowerCase();
        return INTERNAL_HOSTNAMES.some(function (allowed) {
            if (!allowed) return false;
            const a = allowed.toLowerCase();
            return host === a || host.endsWith('.' + a);
        });
    }

    function isExternalLink(anchor) {
        if (!anchor || !anchor.href) return false;

        const href = anchor.getAttribute('href');
        if (!href) return false;

        const trimmed = href.trim().toLowerCase();
        if (
            trimmed.startsWith('#') ||
            trimmed.startsWith('mailto:') ||
            trimmed.startsWith('tel:') ||
            trimmed.startsWith('javascript:') ||
            trimmed.startsWith('sms:')
        ) {
            return false;
        }

        try {
            const url = new URL(anchor.href, window.location.href);
            if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
            return !isInternalHostname(url.hostname);
        } catch (e) {
            return false;
        }
    }

    function flagExternalLinks(root) {
        const scope = root && root.querySelectorAll ? root : document;
        const links = scope.querySelectorAll('a[href]');
        links.forEach(function (link) {
            if (link.dataset.externalProcessed === 'true') return;
            if (!isExternalLink(link)) return;

            if (!link.hasAttribute('target')) {
                link.setAttribute('target', '_blank');
            }

            const rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
            if (rel.indexOf('noopener') === -1) rel.push('noopener');
            if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
            link.setAttribute('rel', rel.join(' '));

            link.dataset.externalProcessed = 'true';
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            flagExternalLinks(document);
        });
    } else {
        flagExternalLinks(document);
    }

    if ('MutationObserver' in window) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType !== 1) return;
                    if (node.tagName === 'A') {
                        flagExternalLinks({ querySelectorAll: function (sel) { return node.matches(sel) ? [node] : []; } });
                    } else {
                        flagExternalLinks(node);
                    }
                });
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
})();
// End External Links Open In New Tab



// Start Smooth Scroll For Anchor Links
(function () {
    const SCROLL_OFFSET_EXTRA = 16;

    function getHeaderOffset() {
        const header = document.querySelector('.header');
        if (!header) return 0;
        const rect = header.getBoundingClientRect();
        const isHidden = rect.bottom <= 0;
        return isHidden ? 0 : rect.height;
    }

    function resolveTarget(hash) {
        if (!hash || hash === '#' || hash === '#0') return null;
        let id;
        try {
            id = decodeURIComponent(hash.slice(1));
        } catch (e) {
            id = hash.slice(1);
        }
        if (!id) return null;
        return document.getElementById(id) || document.querySelector('[name="' + CSS.escape(id) + '"]');
    }

    function smoothScrollTo(target, focus) {
        const top = target.getBoundingClientRect().top + window.pageYOffset
            - getHeaderOffset() - SCROLL_OFFSET_EXTRA;

        window.scrollTo({
            top: Math.max(0, top),
            behavior: 'smooth'
        });

        if (focus) {
            const prevTabIndex = target.getAttribute('tabindex');
            if (prevTabIndex === null) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
            if (prevTabIndex === null) {
                target.addEventListener('blur', function handler() {
                    target.removeAttribute('tabindex');
                    target.removeEventListener('blur', handler);
                });
            }
        }
    }

    document.addEventListener('click', function (e) {
        if (e.defaultPrevented) return;
        if (e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        const anchor = e.target.closest('a[href]');
        if (!anchor) return;

        const target = anchor.getAttribute('target');
        if (target && target !== '_self') return;

        const href = anchor.getAttribute('href');
        if (!href) return;

        let url;
        try {
            url = new URL(anchor.href, window.location.href);
        } catch (err) {
            return;
        }

        const samePage = url.origin === window.location.origin
            && url.pathname === window.location.pathname
            && url.search === window.location.search;

        if (!samePage || !url.hash) return;

        const targetEl = resolveTarget(url.hash);
        if (!targetEl) return;

        e.preventDefault();
        smoothScrollTo(targetEl, true);

        if (history.pushState) {
            history.pushState(null, '', url.hash);
        } else {
            window.location.hash = url.hash;
        }
    });

    function scrollToInitialHash() {
        if (!window.location.hash) return;
        const targetEl = resolveTarget(window.location.hash);
        if (!targetEl) return;

        window.scrollTo(0, 0);

        requestAnimationFrame(function () {
            setTimeout(function () {
                smoothScrollTo(targetEl, false);
            }, 50);
        });
    }

    if (document.readyState === 'complete') {
        scrollToInitialHash();
    } else {
        window.addEventListener('load', scrollToInitialHash);
    }

    window.addEventListener('hashchange', function () {
        const targetEl = resolveTarget(window.location.hash);
        if (targetEl) smoothScrollTo(targetEl, true);
    });
})();
// End Smooth Scroll For Anchor Links
